<template>
  <div class="history_panel" :class="{ 'history_panel--open': isOpen }">
    <button type="button" class="history_panel__toggle" @click="isOpen = !isOpen">
      <span class="history_panel__toggle_main">
        <i class="fal fa-history"></i>
        {{ $t("TITLES.package_history") }}
        <span class="history_panel__count">{{ history.length }}</span>
      </span>
      <i class="fal fa-chevron-down history_panel__chevron"></i>
    </button>

    <div v-show="isOpen" class="history_panel__content">
      <div
        v-for="(item, index) in history"
        :key="index"
        class="history_item"
        :class="{ 'history_item--last': index === history.length - 1 }"
      >
        <div class="history_item__track">
          <span
            class="history_item__dot"
            :style="{ backgroundColor: dotColor(item.status) }"
          ></span>
          <span v-if="index !== history.length - 1" class="history_item__line"></span>
        </div>
        <div class="history_item__body">
          <strong>{{ item.label }}</strong>
          <span>{{ item.created_at }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPackageStatusColor } from "../utils/bundleHelpers";

const STATUS_DOT_COLORS = {
  blue: "#2196f3",
  purple: "#9c27b0",
  orange: "#ff9800",
  cyan: "#00bcd4",
  indigo: "#3f51b5",
  green: "#4caf50",
  red: "#f44336",
  grey: "#9e9e9e",
  "yellow darken-2": "#f9a825",
};

export default {
  name: "PackageHistoryPanel",

  props: {
    history: {
      type: Array,
      default: () => [],
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: this.defaultOpen,
    };
  },

  methods: {
    dotColor(status) {
      const vuetifyColor = getPackageStatusColor(status);
      return STATUS_DOT_COLORS[vuetifyColor] || STATUS_DOT_COLORS.grey;
    },
  },
};
</script>
